import { Component, type ReactNode } from 'react'

import { ErrorCard } from '@/components/ErrorCard'

export type RootErrorBoundaryProps = {
  children: ReactNode
  resetKey?: string
}

type RootErrorBoundaryState = {
  error: unknown | null
}

export class RootErrorBoundary extends Component<
  RootErrorBoundaryProps,
  RootErrorBoundaryState
> {
  state: RootErrorBoundaryState = { error: null }

  static getDerivedStateFromError(error: unknown): RootErrorBoundaryState {
    return { error }
  }

  componentDidUpdate(prevProps: RootErrorBoundaryProps) {
    if (this.state.error && this.props.resetKey !== prevProps.resetKey) {
      this.setState({ error: null })
    }
  }

  private reset = () => {
    this.setState({ error: null })
  }

  render() {
    if (this.state.error) {
      return (
        <div className="p-4">
          <ErrorCard
            error={this.state.error}
            onDismiss={this.reset}
            dismissLabel="Try again"
          />
        </div>
      )
    }

    return this.props.children
  }
}

